export default __webpack_public_path__ + "static/demo1-d59717fb18b8753c186a45bc98e20a29.mp4";